// extracted by mini-css-extract-plugin
export default {"backdrop":"UTCbs65sGmQH09UOP7hT","sidebar":"V7tWjYbSClazQRzD4lUN"};